import { Card, Icon, IconName, Intent } from "@blueprintjs/core";
import { Link } from "react-router-dom";
import "../css/grid-card.css";

export const GridCard = (props: {
  to: string;
  title: string;
  icon?: IconName;
  iconSize?: number;
  intent?: Intent;
}) => (
  <Link to={props.to}>
    <Card elevation={2}>
      <div className="grid-card-div">
        <Icon
          intent={props.intent || "none"}
          iconSize={props.iconSize || 32}
          icon={props.icon}
        />
        <h3>{props.title}</h3>
      </div>
    </Card>
  </Link>
);
